module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Motherless")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#One_33",
      "id": "One_1"
    }
  }, [_c('i', [_vm._v("One ")])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("That SUV falls for years. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Like a burst of lightning I’m back at the twisted fence, pouncing on it, gripping the strained wire links, watching. Disbelieving. Terrified. This moment is so different from what I expected when the sun rose this morning and I made my way here. I rattle the fence with all my strength and have less power than a gust of wind. The barrier doesn’t budge.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The metal is solid and real beneath my fingers. I can feel the pain of it cutting into my joints. The world resists me. Each raindrop strikes me like hail that strips a tree of its leaves. Within seconds I’ve been pounded off the fence. I have to seek shelter. But first, I have to watch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Chevy dives headfirst into the excavation, where everything will soon be laid to rest in a casket of concrete. Hard-hatted workers still finishing their workday scatter. The vehicle finally hits the bottom. It bounces off the exposed net of crosshatched rebar and tumbles twice, the ground sledgehammering the cab.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The final, fatal, upside-down impact sends a shock wave that cuts me in half, and for a long minute, as the flattened SUV stills, the only thing I can do is try to breathe. Yes, the dead do "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("breathe, just in a different dimension. Right now, it takes all my concentration.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("A whispering voice at the back of my mind reminds me that I’ve been this way for some time. Dead, that is. The voice is fear, and it caresses my neck with cold secrets. Death is timeless and irreversible. It begins its work on the human heart long before it strikes its final physical blow. And by then, we’re conditioned to hardly notice it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a sacred moment there’s nothing but the sounds of my wheezing and the pattering of rain drumming on car tops, splatting in its own puddles, pinging the undercarriage of a destroyed car, a crushed life. The rain is shredding me to ribbons, causing pain without injury. I crawl between an outhouse and a piece of plywood tilted against it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gawkers are collecting on the sidewalk where they’re not supposed to be. The especially stupid ones play with their own lives by leaning into the chasm opened up by the truck and the distended fence. The merely careless risk their electronics in the downpour for the sake of a picture or video. One phone slips out of its owner’s hand and plummets into the site. How can these people value their own lives so cheaply? They can’t see what’s right in front of them, and they’re going to call themselves witnesses. What do they know about what happened here today, really? They’ll tell stories that might seem true but aren’t even close, and no one will be able to point out the falsehood.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("But even I feel confused about what just happened. The flimsy pink shoes jutting out of the twisted links look like a lie. Or at least a terrible misunderstanding. I crawl out from under the shelter and reach for them, thinking to pry them out, but I can’t even wiggle the soft soles. My fingers are like floppy feathers trying to ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("jack up a steel beam. I leave the shoes to rot and walk away with nothing, staggering under the pelting rain toward the shelter of a low awning on the other side of the street. The brick building embraces me.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The man in the beret who pointed out the work site is walking away under his umbrella. Did he know what would happen there?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dead have a very broad view of the living, of actions performed out of sight, of thoughts believed to be private. Across the pit, someone standing at the front window of a store is praying. Fifteen cars behind the red light, a nurse has left her car door open and is looking for someone who knows the way down into the site. In the deli on the corner, a crane operator who stopped for dinner at shift’s end has left half a sandwich on the plate and is rushing back to work. Behind me, where the street is jammed with people who want a good story to tell over drinks tonight, an off-duty highway patrolman in sopping wet street clothes is showing his badge to drivers and giving them instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eighty miles away, surviving family members are watching TV in a beach house, unaware that the curtain is rising on a terrible drama in which they will have to take center stage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My children. Almost adults but not quite. Independent but not self-sufficient. Capable but in need of resources.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Who will take care of them now that both their parents are gone?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Who will tell them what happened here?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Raindrops fall from the awning onto my protruding feet, striking like stones. The pain is a living thing.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("I’ve spent a lot of years thinking about what it would have been like to apologize to my kids courageously. Face-to-face, and with a happy ending. My fantasy looks like this: I’d unveil my secrets ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("over cups of strong coffee, and they’d listen, and understand. We’d exchange weak smiles and awkward hugs all around. They’d get answers to their questions. I might eventually get mercy.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("As I said, it’s a fantasy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The rain tapers off. It’s safe to venture out. The skies are gray and night is near. Lights from cars and streetlamps and windows flicker on, resisting darkness. My weak hands smack a mailbox, a skinny tree growing out of the sidewalk, a newspaper stand, a parking meter. I make no sounds, leave no mark.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My children have believed a lie about me for years and years and years. After all this time I can still feel their hurt in my heart. The tether holding me to them is an old rope frayed by years of neglect. I have to find a way to make my confession before it snaps. What I did was unforgivable, but my own pardon is beside the point. My children deserve the truth, and more. They deserve what I could never give them: a mother’s love. I want that much for them even at this late date. Because some part of us always needs mothering no matter how old we are.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My plodding walk quickly becomes a jog fueled by a new goal. I turn west and break into a run.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec81b940","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter6.vue
// module id = 87
// module chunks = 0